/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_Subtitle_LinkInputs */

const en_idea_subtitle_link = /** @type {(inputs: Idea_Subtitle_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your codebase`)
};

const id_idea_subtitle_link = /** @type {(inputs: Idea_Subtitle_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`codebase kamu`)
};

/**
* | output |
* | --- |
* | "your codebase" |
*
* @param {Idea_Subtitle_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_subtitle_link = /** @type {((inputs?: Idea_Subtitle_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_Subtitle_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_subtitle_link(inputs)
	return en_idea_subtitle_link(inputs)
});